import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setFormAnswer } from "../../ducks/checkoutSlice";
import QRCodeScanner from "../../components/QRCodeScanner";
import { BackButton, TotemStep } from "./TotemStep";

const STEP_Comanda = "STEP_Comanda";

function ComandaScanJava({ moveStep }) {
  const dispatch = useDispatch();

  const onScanComanda = (qrData) => {
    dispatch(
      setFormAnswer({
        name: "comandaId",
        value: qrData,
      }),
    );
    moveStep(1);
  };

  // Os handlers ficam num ref para que o registro na ponte nativa rode uma vez
  // só, sem depender da identidade das funções a cada render.
  const handlersRef = React.useRef();
  // Sem lista de dependências: roda depois de cada render, mantendo o ref em
  // dia sem escrever nele em fase de render.
  useEffect(() => {
    handlersRef.current = { onScanComanda, moveStep };
  });

  useEffect(() => {
    // Antes estas duas atribuições ficavam no corpo do componente: refaziam a
    // cada render e nunca eram desfeitas. Se o nativo chamasse depois de sair
    // da tela, caía num setState de componente desmontado.
    window.javaNative_onScanComanda = (qrData) =>
      handlersRef.current.onScanComanda(qrData);
    window.javaNative_moveStep = (...args) =>
      handlersRef.current.moveStep(...args);

    window.posNativeInterface.startScanComanda();

    return () => {
      delete window.javaNative_onScanComanda;
      delete window.javaNative_moveStep;
    };
  }, []);

  return <div></div>;
}

function ComandaScanJS({ moveStep }) {
  const dispatch = useDispatch();

  const onScanComanda = (qrData) => {
    dispatch(
      setFormAnswer({
        name: "comandaId",
        value: qrData,
      }),
    );
    moveStep(1);
  };

  return (
    <TotemStep
      title="Aponte sua comanda para a câmera"
      footer={<BackButton onClick={() => moveStep(false)} />}
    >
      <QRCodeScanner onScanComanda={onScanComanda} />
    </TotemStep>
  );
}

export default function ComandaScan({ step, moveStep }) {
  if (step !== STEP_Comanda) return null;

  return window.posNativeInterface ? (
    <ComandaScanJava moveStep={moveStep} />
  ) : (
    <ComandaScanJS moveStep={moveStep} />
  );
}
